const PERMISSIONS = {
  HARVEST_SCHEDULE: {
    VIEW: "View_Harvest_Schedule_Page",
    EDIT: "Edit_Harvest_Schedule_Page",
  },
  SCANNING_SESSIONS: {
    VIEW: "View_Scanning_Sessions_Page",
    EDIT: "Edit_Scanning_Sessions_Page",
  },
  REPORTING: {
    VIEW: "View_Reporting_Page",
    EDIT: "Edit_Reporting_Page",
  },
};

export default PERMISSIONS;
